import { gql } from "@apollo/client";

export const SKED_AUTH = gql`
  mutation SkedAuth($token: String!) {
    skedAuth(token: $token) {
      token
    }
  }
`;

export interface SkedAuthData {
  skedAuth: { token: string };
}

export interface SkedAuthVariables {
  token: string;
}
